import React, {
  useState, useEffect, useRef, memo, useContext,
} from 'react';
import {
  Box, Typography, Checkbox, Grid,
} from '@material-ui/core';
import {
  MoreVert as MoreVertIcon, CheckCircle, RadioButtonUnchecked,
} from '@material-ui/icons';
import { makeStyles, withStyles, useTheme } from '@material-ui/styles';
import { func, object } from 'prop-types';
import cookies from 'react-cookies';
import { useError } from '@avon/component-library';
import Swipeout from '../Swipeout';
import bellIcon from './assets/bell.svg';
import emailIcon from './assets/email.svg';
import deleteIcon from './assets/delete.svg';
import deleteAction from './assets/deleteAction.svg';
import readAction from './assets/readAction.svg';

import backIcon from './assets/back.svg';
import NotificationDetail from './NotificationDetail';
import CompletedBanner from './CompletedBanner';
import Empty from './NotificationEmpty';
import {
  getNotificationList,
  deleteNotification,
  batchDeleteNotification,
  updateStatusForNotifications,
  getNotificationSnsInfo,
  getNotificationSnsList,
  getNotificationsInfo,
  getNotificationCount,
} from '../../utils/api/endpoints';
import { formatNotificationDate } from '../../utils/formatDate';
import getDeviceType, { isMobile, isTablet } from '../../utils/getDeviceType';
import HomeContext from '../../home/HomeContext';
import LoadingIcon from '../LoadingIcon';

const useStyles = makeStyles(theme => ({
  notify: {
    display: 'flex',
    height: '100%',
    // overflow: 'auto',
    borderRadius: 16,
    maxHeight: '1100px',
  },
  notifyContainer: {
    position: 'relative',
    // flex: e => (e.deviceType === 'tablet' ? '1' : '0.45'),
    width: e => (e.deviceType === 'tablet' ? '100%' : '45%'),
    height: '100%',
    display: e => (e.deviceType === 'tablet' && e.clickId ? 'none' : 'flex'),
    flexDirection: 'column',
    borderRight: '1px solid rgba(0, 0, 0, 0.0784)',
  },
  header: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    padding: '0 24px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.0784)',
  },
  notificationSelect: {
    position: 'absolute',
    top: 'calc(50% + 24px)',
    left: e => (e.language === 'ar' ? -24 : 'unset'),
    right: e => (e.language === 'ar' ? 'unset' : -24),
    zIndex: 10,
    padding: '12px',
    border: '1px solid #E4EDED',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    background: '#ffffff',

    '&::before': {
      content: "''",
      position: 'absolute',
      top: -10,
      right: 26,
      zIndex: 10,
      borderBottom: '10px solid #E4EDED',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      width: 0,
      height: 0,
    },
    '&::after': {
      content: "''",
      position: 'absolute',
      top: -9,
      right: 26,
      zIndex: 10,
      borderBottom: '10px solid #FFFFFF',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      width: 0,
      height: 0,
    },
  },
  notificationItemList: {
    '&:first-child': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.0784314)',
      paddingBottom: 6,
      marginBottom: 6,
    },
  },
  selectItem: {
    padding: '0 6px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    lineHeight: '34px',
    color: '#181818',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      background: '#F6F9F9',
    },
  },
  notifyList: {
    overflowY: 'auto',
    height: 'calc(100% - 100px)',
    overflowX: 'hidden',
  },
  notifyListItem: {
    padding: '24px 16px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.0784)',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
    minHeight: '102px',
  },
  notificationTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#181818',
    marginRight: 12,
    // whiteSpace: 'nowrap',
    display: '-webkit-box',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    'word-break': 'break-word',
  },
  notificationDesc: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#181818',
  },
  notificationDate: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#181818',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
  },
  notifyDetailContainer: {
    // eslint-disable-next-line
    display: e => (e.deviceType === 'tablet' ? (
      e.clickId ? 'block' : 'none'
    ) : 'block'),
    // flex: e => (e.deviceType === 'tablet' && e.clickId ? 1 : '0.55'),
    width: e => (e.deviceType === 'tablet' && e.clickId ? '100%' : '55%'),
    height: '100%',
  },
  emptyDetail: {
    background: '#E4EDED',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    '& img': {
      width: 228,
      height: 228,
    },
  },
}));

const CustomerCheckbox = withStyles(theme => ({
  root: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    marginRight: 12,
    '&$checked': {
      color: theme.palette.colors.corePink,
      padding: 0,
      marginRight: 12,
    },
  },
  checked: {},
}))(props => <Checkbox icon={<RadioButtonUnchecked />} checkedIcon={<CheckCircle />} {...props} />);

// eslint-disable-next-line
const Notification = memo(({ callApi, setMenuItem, redirectTo, wsData }) => {
  const langCd = cookies.load('langCd');
  const mrktCd = cookies.load('mrktCd');
  const notificationListRef = useRef();
  // eslint-disable-next-line
  const [{ back }, dispatch] = useContext(HomeContext);

  const { setError, cleanToastBanner } = useError();
  const [snsInfo, setSnsInfo] = useState({});
  const [snsList, setSnsList] = useState({});
  // eslint-disable-next-line
  const [notificationSelectList, setNotificationSelectList] = useState();
  const [notificationList, setNotificationList] = useState([]);
  const [mouseId, setMouseId] = useState();
  const [clickId, setclickId] = useState();
  const [displaySelect, setDisplaySelect] = useState(false);
  const [displayDetailSelect, setDisplayDetailSelect] = useState(false);
  const [notifycation, setNotifycation] = useState({});
  const [pageIndex, setPageIndex] = useState(0);
  const [isRequesting, setIsRequesting] = useState(false);
  const [isRequestFinish, setIsRequestFinish] = useState(false);
  const [completedLabel, setCompletedLabel] = useState();
  const [completedShow, setCompletedShow] = useState(false);
  const [timer, setTimer] = useState();
  const [completedCount, setCompletedCount] = useState(0);
  const [type, setType] = useState();
  const [sendData, setSendData] = useState({});
  const [selectIds, setSelectIds] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [nonDeleteNotifications, setNonDeleteNotifications] = useState(0);
  const [disableClick, setDisableClick] = useState(true);

  const classes = useStyles({
    language: langCd,
    deviceType: getDeviceType(),
    clickId,
  });
  const theme = useTheme();

  const getNotificationNumber = async () => {
    const { unreadCount: count } = await callApi(getNotificationCount());
    dispatch({ unreadCount: count === 0 ? '0' : count });
  };

  const getNotificationConfigData = async () => {
    const { jsonObject: { info, button } } = await callApi(getNotificationSnsInfo());
    setSnsInfo({ info, button });
    setDisableClick(false);

    await getNotificationNumber();
    // eslint-disable-next-line
    const { jsonObject: { list = {}, selectList, detailSelectList } } = await callApi(getNotificationSnsList());
    setNotificationSelectList(selectList);
    setSnsList({ list, selectList, detailSelectList });

    await callApi(getNotificationsInfo());
  };

  useEffect(() => {
    getNotificationConfigData();
  }, []);

  const findNotificationList = async () => {
    setIsRequesting(true);
    setIsRequestFinish(false);
    try {
      cleanToastBanner();
      const {
        records, pagination: { pageSize },
        countNum: { unreadCount: count },
      } = await callApi(getNotificationList({
        userId: sessionStorage.getItem('userId'),
        status: ['READ', 'UNREAD'],
        pageIndex,
        pageSize: 10,
      }));
      if (pageSize > records.length) {
        setIsRequestFinish(true);
        setPageIndex(0);
      }
      records.forEach((item) => {
        // eslint-disable-next-line
        item.checked = false;
      });
      if (pageIndex === 0) {
        setUnreadCount(count);
        setNotificationList([...records]);
      } else {
        setNotificationList([...notificationList, ...records]);
      }
    } catch ({ error }) {
      setError(error);
    } finally {
      setIsRequesting(false);
    }
  };

  useEffect(() => {
    if (wsData) {
      if (pageIndex === 0) {
        findNotificationList();
      } else {
        setPageIndex(0);
        setIsRequestFinish(false);
      }
    }
  }, [wsData]);

  useEffect(() => {
    if (!clickId) {
      if (pageIndex === 0) {
        findNotificationList();
      } else {
        setPageIndex(0);
        setIsRequestFinish(false);
      }
    }
  }, [clickId]);

  useEffect(() => {
    if (!isRequestFinish && pageIndex !== 0) {
      findNotificationList();
    }
  }, [pageIndex]);

  const handlePageScrollLoadData = (e) => {
    const {
      offsetHeight, scrollTop, scrollHeight, clientHeight,
    } = e.target;
    const scrollBarWidth = offsetHeight - clientHeight;
    if (offsetHeight + scrollTop >= scrollHeight + scrollBarWidth - 1) {
      if (!isRequesting) {
        setPageIndex(page => page + 1);
      }
    }
  };

  useEffect(() => {
    notificationListRef.current.addEventListener('scroll', handlePageScrollLoadData, false);
    return () => {
      notificationListRef.current.removeEventListener('scroll', handlePageScrollLoadData);
    };
  }, []);

  useEffect(() => {
    let selectCount = 0;
    let readCheckedCount = 0;
    let unReadCountTemp = 0;
    let nonDeleteCount = 0;
    // eslint-disable-next-line
    for (const { checked, status } of notificationList) {
      if (checked) {
        selectCount += 1;
        if (status === 'READ') {
          readCheckedCount += 1;
        }
        if (status === 'UNREAD') {
          unReadCountTemp += 1;
        }
      }
      if (status.indexOf('DELETE') === -1) {
        nonDeleteCount += 1;
      }
    }
    setNonDeleteNotifications(nonDeleteCount);

    if (!notificationSelectList || notificationSelectList.length === 0) {
      return;
    }

    if (selectCount === notificationList.length) {
      if (readCheckedCount === selectCount) {
        setNotificationSelectList((item) => {
          const list = JSON.parse(JSON.stringify(item));
          list[0][0].hidden = true;
          list[0][1].hidden = false;
          list[0][2].hidden = false;
          list[1][0].disable = true;
          list[1][1].disable = false;
          return list;
        });
      } else if (unReadCountTemp === selectCount) {
        setNotificationSelectList((item) => {
          const list = JSON.parse(JSON.stringify(item));
          list[0][0].hidden = false;
          list[0][1].hidden = true;
          list[0][2].hidden = false;
          list[1][0].disable = true;
          list[1][1].disable = false;
          return list;
        });
      } else {
        setNotificationSelectList((item) => {
          const list = JSON.parse(JSON.stringify(item));
          list[0][0].hidden = false;
          list[0][1].hidden = false;
          list[0][2].hidden = false;
          list[1][0].disable = true;
          list[1][1].disable = false;
          return list;
        });
      }
    } else if (selectCount !== 0) {
      if (readCheckedCount === 0) {
        setNotificationSelectList((item) => {
          const list = JSON.parse(JSON.stringify(item));
          list[0][0].hidden = false;
          list[0][1].hidden = true;
          list[0][2].hidden = false;
          list[1][0].disable = false;
          list[1][1].disable = false;
          return list;
        });
      } else if (unReadCountTemp === 0) {
        setNotificationSelectList((item) => {
          const list = JSON.parse(JSON.stringify(item));
          list[0][0].hidden = true;
          list[0][1].hidden = false;
          list[0][2].hidden = false;
          list[1][0].disable = false;
          list[1][1].disable = false;
          return list;
        });
      } else {
        setNotificationSelectList((item) => {
          const list = JSON.parse(JSON.stringify(item));
          list[0][0].hidden = false;
          list[0][1].hidden = false;
          list[0][2].hidden = false;
          list[1][0].disable = false;
          list[1][1].disable = false;
          return list;
        });
      }
    } else {
      setNotificationSelectList((item) => {
        const list = JSON.parse(JSON.stringify(item));
        list[0][0].hidden = false;
        list[0][1].hidden = false;
        list[0][2].hidden = false;
        list[1][0].disable = false;
        list[1][1].disable = true;
        return list;
      });
    }
  }, [notificationList]);

  const handleClickMore = () => {
    setDisplayDetailSelect(false);
    setDisplaySelect(!displaySelect);
  };

  const handleDrowDownRequest = async (params, len, label, typeCopy, ids) => {
    try {
      // setCompletedShow(false);
      if (completedShow) {
        return;
      }
      cleanToastBanner();
      setSendData(params);
      setSelectIds(ids);
      setType(typeCopy);
      setDisplaySelect(false);
      setCompletedCount(len);
      setCompletedLabel(label);

      let count = 0;
      let selectList = [];
      if (typeCopy !== 'delete') {
        await callApi(params);
        selectList = notificationList.map((item) => {
          if (ids.some(id => item.id === id)) {
            if (typeCopy === 'READ') {
              if (item.status !== 'UNREAD') {
                count += 1;
              }
              // eslint-disable-next-line
              item.status = 'UNREAD';
            } else {
              if (item.status !== 'READ') {
                count -= 1;
              }
              // eslint-disable-next-line
              item.status = 'READ';
            }
          }
          // eslint-disable-next-line
          item.checked = false;
          return item;
        }) || [];
        await getNotificationNumber();
      } else {
        selectList = notificationList.map((item) => {
          if (ids.some(id => item.id === id)) {
            if (item.status === 'UNREAD') {
              count -= 1;
            }
            // eslint-disable-next-line
            item.status += ' DELETE';
          }
          // eslint-disable-next-line
          item.checked = false;
          return item;
        }) || [];
      }
      setNotificationList([...selectList]);
      setCompletedShow(true);
      // eslint-disable-next-line
      setUnreadCount(c => c += count);
    } catch (error) {
      setError(error);
    }
  };

  const handleCloseCompleteBnnaer = async () => {
    clearTimeout(timer);
    setCompletedShow(false);
    if (type === 'delete') {
      await callApi(sendData);
      await getNotificationNumber();
    }
  };

  useEffect(() => {
    let timerCopy = null;
    if (completedShow) {
      timerCopy = setTimeout(async () => {
        if (type === 'delete') {
          await callApi(sendData);
          await getNotificationNumber();
        }
        setCompletedShow(false);
        clearTimeout(timer);
      }, 3000);
      setTimer(timerCopy);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [completedShow]);

  const handleClickSelectItem = async (disable, typeCopy) => {
    if (disable) {
      return;
    }
    if (typeCopy === 'selectAll') {
      const notificationListCopy = JSON.parse(JSON.stringify(notificationList));
      notificationListCopy.forEach((item) => {
        // eslint-disable-next-line
        item.checked = true;
      });
      setNotificationList(notificationListCopy);
    } else if (typeCopy === 'unSelectAll') {
      const notificationListCopy = JSON.parse(JSON.stringify(notificationList));
      notificationListCopy.forEach((item) => {
        // eslint-disable-next-line
        item.checked = false;
      });
      setNotificationList(notificationListCopy);
    } else { // ['read', 'unread', 'delete]
      const idList = [];
      // eslint-disable-next-line
      notificationList.forEach(({ checked, id, status }) => {
        if (checked === true) {
          if (typeCopy !== 'delete') {
            if (typeCopy.toUpperCase() !== status) {
              idList.push(id);
            }
          } else {
            idList.push(id);
          }
        }
      });
      const len = idList.length;
      if (len !== 0) {
        if (typeCopy === 'delete') {
          handleDrowDownRequest(batchDeleteNotification(idList), len, `${idList.length > 1 ? snsList.list.deletedHeaderPluralr : snsList.list.deletedHeaderSingular}`, 'delete', idList);
        } else if (typeCopy === 'unread') {
          handleDrowDownRequest(updateStatusForNotifications({ idList, status: 'UNREAD' }), len, `${idList.length > 1 ? snsList.list.markUnreadHeaderPluralr : snsList.list.markUnreadHeaderSingular}`, 'READ', idList);
        } else {
          handleDrowDownRequest(updateStatusForNotifications({ idList, status: 'READ' }), len, `${idList.length > 1 ? snsList.list.markReadHeaderPluralr : snsList.list.markReadHeaderSingular}`, 'UNREAD', idList);
        }
      }
    }
    setDisplaySelect(false);
  };

  const handleReadOrDelete = async (id, status) => {
    if (status) {
      handleDrowDownRequest(updateStatusForNotifications({ idList: [id], status: status === 'UNREAD' ? 'READ' : 'UNREAD' }),
        1,
        status === 'UNREAD' ? snsList.list.markReadHeaderSingular : snsList.list.markUnreadHeaderSingular,
        status,
        [id]);
    } else {
      handleDrowDownRequest(deleteNotification(id), 1, snsList.list.deletedHeaderSingular, 'delete', [id]);
    }
  };

  const handleAllRead = async () => {
    await callApi(updateStatusForNotifications({ idList: 'all', status: Number(unreadCount) === 0 ? 'UNREAD' : 'READ' }));
    if (pageIndex === 0) {
      findNotificationList();
    } else {
      setPageIndex(0);
      setIsRequestFinish(false);
    }
  };

  const handleClickUndo = async () => {
    setCompletedShow(false);
    clearTimeout(timer);

    let count = 0;
    let selectList = [];
    if (type !== 'delete') {
      const data = JSON.parse(JSON.stringify(sendData));
      data.data.status = type;
      await callApi(data);
      selectList = notificationList.map((item) => {
        if (selectIds.some(id => item.id === id)) {
          if (type === 'READ') {
            if (item.status !== 'READ') {
              count -= 1;
            }
          } else if (item.status !== 'UNREAD') {
            count += 1;
          }
          // eslint-disable-next-line
          item.status = type;
        }
        return item;
      }) || [];
    } else {
      selectList = notificationList.map((item) => {
        if (selectIds.some(id => item.id === id)) {
          let { status } = item;
          // eslint-disable-next-line
          status = status.split(' ')[0];
          // eslint-disable-next-line
          item.status = status;
          if (status === 'UNREAD') {
            count += 1;
          }
        }
        return item;
      }) || [];
    }
    await getNotificationNumber();
    // eslint-disable-next-line
    setUnreadCount(c => c += count);
    setNotificationList([...selectList]);
  };

  const toggleShow = () => {
    setDisplaySelect(false);
  };

  useEffect(() => {
    document.addEventListener('click', toggleShow, false);

    return () => {
      document.removeEventListener('click', toggleShow);
    };
  });

  useEffect(() => {
    if (back !== 'notification') {
      setclickId('');
    }
  }, [back]);

  useEffect(() => {
    if (!clickId) {
      dispatch({ back: 'init' });
    }
  }, [clickId]);

  const handleItemUnread = async (
    id, header, createDate, category, name, middleName, surName, status, index,
  ) => {
    console.log(notificationList, index);
    if (disableClick) {
      return;
    }
    setNotifycation({
      id, header, createDate, category, name, middleName, surName,
    });
    setclickId(id);
    if (isTablet()) {
      dispatch({ back: 'notification' });
    }
    if (status === 'UNREAD') {
      const notificationListCopy = JSON.parse(JSON.stringify(notificationList));
      notificationListCopy[index].status = 'READ';
      setNotificationList(notificationListCopy);
      await getNotificationNumber();
      // eslint-disable-next-line
      setUnreadCount(c => c -= 1);
    }
  };

  // eslint-disable-next-line
  const SwipeActionButton = ({ icon, text }) => (
    <Box style={{
      fontFamily: 'Montserrat',
      fontSize: 14,
      fontWeight: 500,
    }}
    >
      <img src={icon} alt={`${text}-action-icon`} />
      <Box>{text}</Box>
    </Box>
  );

  return isMobile() ? (
    <Box style={{
      height: '100%',
    }}
    >
      <Box
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px 0',
        }}
      >
        <Box
          style={{
            position: 'absolute',
            left: 16,
            width: 24,
            height: 24,
          }}
          onClick={() => setMenuItem('home')}
        >
          <img src={backIcon} alt="back-icon" />
        </Box>
        <Box style={{
          fontFamily: 'Montserrat',
          fontWeight: 500,
          fontSize: 16,
          lineHeight: '24px',
          color: '#181818',
        }}
        >
          {snsList.list && snsList.list.notifications}
        </Box>
      </Box>
      {
        notificationList && notificationList.length !== 0 && (
          <Box style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 20px',
            height: 40,
            background: '#E4EDED',
          }}
          >
            <Box style={{
              fontFamily: 'Montserrat',
              fontWeight: 600,
              fontSize: 12,
              lineHeight: '16px',
              color: '#546264',
            }}
            >
              {unreadCount}
              {' '}
              {snsList.list && snsList.list.new}
            </Box>
            <Box
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 500,
                fontSize: 16,
                lineHeight: '24px',
                color: theme.palette.colors.corePink,
              }}
              onClick={handleAllRead}
            >
              {/* eslint-disable-next-line */}
              {`${Number(unreadCount) === 0 ?
                (snsList.list ? snsList.list.markUnread : '')
                : (snsList.list ? snsList.list.markRead : '')}`}
            </Box>
          </Box>
        )
      }
      <Box
        ref={notificationListRef}
        style={{
          background: '#F6F9F9',
          height: notificationList.length !== 0 ? 'calc(100% - 84px)' : 'calc(100% - 44px)',
          overflow: 'auto',
        }}
      >
        {
          notificationList && notificationList.length !== 0 && nonDeleteNotifications !== 0 ? (
            <>
              {notificationList.map(({
                id, header, createDate, category, name, middleName, surName, status,
                pushType, content,
              }, index) => (
                <Swipeout
                  style={{ backgroundColor: 'gray' }}
                  autoClose
                  right={[
                    {
                      // eslint-disable-next-line
                      text: <SwipeActionButton icon={deleteAction} text={snsList.list && snsList.list.delete} />,
                      onPress: () => handleReadOrDelete(id),
                      style: { backgroundColor: '#F09F87', color: '#181818' },
                    },
                  ]}
                  left={[
                    {
                      // eslint-disable-next-line
                      text: <SwipeActionButton icon={readAction} text={status === 'UNREAD' ? snsList.list && snsList.list.read : snsList.list && snsList.list.unread} />,
                      onPress: () => handleReadOrDelete(id, status),
                      style: { backgroundColor: '#1A8282', color: 'white' },
                    },
                  ]}
                >
                  <Box
                    key={`notify-list-item-key-${id}`}
                    style={{
                      padding: '11px 16px 17px',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                      background: '#ffffff',
                      display: status.indexOf('DELETE') !== -1 ? 'none' : 'block',
                    }}
                    onClick={() => handleItemUnread(
                      id, header, createDate, category, name, middleName, surName, status, index,
                    )}
                  >
                    <Box style={{
                      fontFamily: 'Montserrat',
                      fontWeight: status === 'UNREAD' ? 700 : 400,
                      fontSize: '16px',
                      lineHeight: '24px',
                      color: '#181818',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                    >
                      {
                        // eslint-disable-next-line
                        (pushType === 'INDIVIDUAL' || pushType === 'BROADCAST') ? header
                          : ((['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                            `${(surName || '') + (middleName ? (` ${middleName} `) : ' ') + (name || '')}`
                          ) : (
                            `${(name || '') + (middleName ? (` ${middleName} `) : ' ') + (surName || '')}`
                          ))
                      }
                    </Box>
                    <Box style={{
                      fontFamily: 'Montserrat',
                      fontWeight: 500,
                      fontSize: '14px',
                      lineHeight: '20px',
                      color: '#181818',
                    }}
                    >
                      {(pushType === 'INDIVIDUAL' || pushType === 'BROADCAST') ? content : header}
                    </Box>
                    <Box style={{
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      lineHeight: '20px',
                      color: '#707677',
                    }}
                    >
                      {formatNotificationDate(createDate, langCd, 'DD MMM, HH:mm',
                        snsList.list ? snsList.list.toady : '',
                        snsList.list ? snsList.list.yesterday : '')}
                    </Box>
                  </Box>
                </Swipeout>
              ))}
              {isRequesting ? <LoadingIcon disabled={false} /> : ''}
            </>
          ) : <Empty snsList={snsList} />
        }
        <CompletedBanner
          count={completedCount}
          show={completedShow}
          setCompletedShow={handleCloseCompleteBnnaer}
          label={completedLabel}
          onClick={handleClickUndo}
        />
      </Box>
      {
        clickId && (
          <Box style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            background: '#ffffff',
          }}
          >
            <NotificationDetail
              callApi={callApi}
              notifycation={notifycation}
              clickId={clickId}
              setclickId={setclickId}
              onReadOrDelete={handleReadOrDelete}
              redirectTo={redirectTo}
              snsInfo={snsInfo}
              snsList={snsList}
              setListSelect={setDisplaySelect}
              displayDetailSelect={displayDetailSelect}
              setDisplayDetailSelect={setDisplayDetailSelect}
            />
          </Box>
        )
      }
    </Box>
  )
    : (
      <Box className={classes.notify}>
        <Box className={classes.notifyContainer}>
          <Box className={classes.header}>
            <Typography
              style={{
                fontFamily: 'Montserrat',
                fontWeight: '500',
                fontSize: '24px',
                lineHeight: '32px',
                color: '#000000',
              }}
            >
              {snsList.list && snsList.list.notifications}
            </Typography>
            <Box style={{
              position: 'relative',
              cursor: 'pointer',
            }}
            >
              <Box onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                handleClickMore();
              }}
              >
                <MoreVertIcon />
              </Box>
              <Box
                className={classes.notificationSelect}
                style={{ display: displaySelect ? 'unset' : 'none' }}
              >
                {
                  notificationSelectList && notificationSelectList.map((itemList, i) => (
                    <Box
                      className={classes.notificationItemList}
                      key={`notification-item-list-key-${i}`}
                    >
                      {
                        itemList.map(({
                          label, value, disable, hidden,
                        }) => (
                          <Box
                            className={classes.selectItem}
                            key={`notification-select-item-key-${value}`}
                            style={{
                              color: disable ? '#A2ACAE' : 'unset',
                              display: hidden ? 'none' : 'flex',
                            }}
                            onClick={() => handleClickSelectItem(disable, value)}
                          >
                            {label}
                          </Box>
                        ))
                      }
                    </Box>
                  ))
                }
              </Box>
            </Box>
          </Box>
          <Box
            ref={notificationListRef}
            className={classes.notifyList}
          >
            {
              notificationList && notificationList.length !== 0 && nonDeleteNotifications !== 0 ? (
                <>
                  {
                    notificationList.map(({
                      id, checked, header, createDate, category, name, middleName, surName, status,
                      content, pushType,
                    }, index) => (
                      <>
                        {
                          isTablet() ? (
                            <Swipeout
                              style={{ backgroundColor: 'gray' }}
                              autoClose
                              right={[
                                {
                                  // eslint-disable-next-line
                                  text: <SwipeActionButton icon={deleteAction} text={snsList.list && snsList.list.delete} />,
                                  onPress: () => handleReadOrDelete(id),
                                  style: { backgroundColor: '#F09F87', color: '#181818' },
                                },
                              ]}
                              left={[
                                {
                                  // eslint-disable-next-line
                                  text: <SwipeActionButton icon={readAction} text={status === 'UNREAD' ? snsList.list && snsList.list.read : snsList.list && snsList.list.unread} />,
                                  onPress: () => handleReadOrDelete(id, status),
                                  style: { backgroundColor: '#1A8282', color: 'white' },
                                },
                              ]}
                            >
                              <Box
                                className={classes.notifyListItem}
                                key={`notify-list-item-key-${id}`}
                                onMouseEnter={() => setMouseId(id)}
                                onMouseLeave={() => setMouseId('')}
                                onClick={
                                  // eslint-disable-next-line
                                  () => handleItemUnread(id, header, createDate, category, name, middleName, surName, status, index)
                                }
                                style={{
                                  background: clickId === id ? '#F6F9F9' : 'unset',
                                  display: status.indexOf('DELETE') !== -1 ? 'none' : 'flex',
                                }}
                              >
                                <Box style={{ display: 'flex' }}>
                                  <Box style={{
                                    visibility: checked || (mouseId === id) ? 'unset' : 'hidden',
                                  }}
                                  >
                                    <CustomerCheckbox
                                      checked={checked}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                      }}
                                      onChange={() => {
                                        // eslint-disable-next-line
                                        const copyNotificationList = JSON.parse(JSON.stringify(notificationList));
                                        const item = copyNotificationList[index];
                                        item.checked = !checked;
                                        copyNotificationList[index] = item;
                                        setNotificationList([...copyNotificationList]);
                                      }}
                                    />
                                  </Box>
                                  <Box>
                                    <Box style={{
                                      display: 'flex',
                                      alignItems: 'flex-start',
                                      marginBottom: 6,
                                      flexWrap: 'wrap',
                                    }}
                                    >
                                      <Box
                                        className={classes.notificationTitle}
                                        style={{
                                          fontWeight: status === 'UNREAD' ? 700 : 400,
                                        }}
                                      >
                                        {
                                          // eslint-disable-next-line
                                          (pushType === 'INDIVIDUAL' || pushType === 'BROADCAST') ? header
                                            : ((['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                                              `${(surName || '') + (middleName ? (` ${middleName} `) : ' ') + (name || '')}`
                                            ) : (
                                              `${(name || '') + (middleName ? (` ${middleName} `) : ' ') + (surName || '')}`
                                            ))
                                        }
                                      </Box>
                                      <Box style={{
                                        display: (pushType === 'INDIVIDUAL' || pushType === 'BROADCAST' || !category) ? 'none' : 'flex',
                                        alignItems: 'center',
                                        padding: '4px 10px',
                                        height: '20px',
                                        background: '#BAE1E9',
                                        borderRadius: '10px',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        lineHeight: '16px',
                                        color: '#293132',
                                        whiteSpace: 'nowrap',
                                      }}
                                      >
                                        {snsInfo.info ? snsInfo.info[category] : category}
                                      </Box>
                                    </Box>
                                    <Box className={classes.notificationDesc}>
                                      {(pushType === 'INDIVIDUAL' || pushType === 'BROADCAST') ? content : header}
                                    </Box>
                                  </Box>
                                </Box>
                                <Box style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-end',
                                }}
                                >
                                  <Box style={{
                                    visibility: checked || (mouseId === id) ? 'unset' : 'hidden',
                                    height: 24,
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    marginBottom: 10,
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                  }}
                                  >
                                    <Box
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                        handleReadOrDelete(id, status);
                                      }}
                                    >
                                      <img
                                        src={emailIcon}
                                        alt="email-icon"
                                        style={{
                                          marginRight: 12,
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                        handleReadOrDelete(id);
                                      }}
                                    >
                                      <img
                                        src={deleteIcon}
                                        alt="delete-icon"
                                      />
                                    </Box>
                                  </Box>
                                  <Box className={classes.notificationDate}>
                                    {formatNotificationDate(createDate, langCd, 'DD MMM, HH:mm',
                                      snsList.list ? snsList.list.toady : '',
                                      snsList.list ? snsList.list.yesterday : '')}
                                  </Box>
                                </Box>
                              </Box>
                            </Swipeout>
                          ) : (
                            <Box
                              className={classes.notifyListItem}
                              key={`notify-list-item-key-${id}`}
                              onMouseEnter={() => setMouseId(id)}
                              onMouseLeave={() => setMouseId('')}
                              onClick={
                                // eslint-disable-next-line
                                () => handleItemUnread(id, header, createDate, category, name, middleName, surName, status, index)
                              }
                              style={{
                                background: clickId === id ? '#F6F9F9' : 'unset',
                                display: status.indexOf('DELETE') !== -1 ? 'none' : 'flex',
                              }}
                            >
                              <Grid container>
                                <Grid item xs={1}>
                                  <Box style={{
                                    visibility: checked || (mouseId === id) ? 'unset' : 'hidden',
                                  }}
                                  >
                                    <CustomerCheckbox
                                      checked={checked}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                      }}
                                      onChange={() => {
                                        // eslint-disable-next-line
                                        const copyNotificationList = JSON.parse(JSON.stringify(notificationList));
                                        const item = copyNotificationList[index];
                                        item.checked = !checked;
                                        copyNotificationList[index] = item;
                                        setNotificationList([...copyNotificationList]);
                                      }}
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={11}>
                                  <Box style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    marginBottom: 6,
                                  }}
                                  >
                                    <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                                      <Grid item container xs={12} md={9} lg={9} alignItems="center">
                                        <Box
                                          className={classes.notificationTitle}
                                          style={{
                                            fontWeight: status === 'UNREAD' ? 700 : 400,
                                          }}
                                        >
                                          {
                                            // eslint-disable-next-line
                                            (pushType === 'INDIVIDUAL' || pushType === 'BROADCAST') ? header
                                              : ((['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                                                `${(surName || '') + (middleName ? (` ${middleName} `) : ' ') + (name || '')}`
                                              ) : (
                                                `${(name || '') + (middleName ? (` ${middleName} `) : ' ') + (surName || '')}`
                                              ))
                                          }
                                        </Box>
                                        <Box style={{
                                          display: (pushType === 'INDIVIDUAL' || pushType === 'BROADCAST' || !category) ? 'none' : 'flex',
                                          alignItems: 'center',
                                          padding: '4px 10px',
                                          background: '#BAE1E9',
                                          borderRadius: '10px',
                                          fontFamily: 'Montserrat',
                                          fontWeight: 500,
                                          fontSize: '12px',
                                          lineHeight: '16px',
                                          color: '#293132',
                                          width: 'fit-content',
                                          whiteSpace: checked || (mouseId === id) ? 'unset' : 'nowrap',
                                          height: checked || (mouseId === id) ? 'unset' : '20px',
                                        }}
                                        >
                                          {snsInfo.info ? snsInfo.info[category] : category}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={3} lg={3}>
                                        <Box style={{
                                          visibility: checked || (mouseId === id) ? 'unset' : 'hidden',
                                          height: 24,
                                          alignItems: 'center',
                                          justifyContent: 'flex-end',
                                          display: 'flex',
                                          flexWrap: 'nowrap',
                                        }}
                                        >
                                          <Box
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.nativeEvent.stopImmediatePropagation();
                                              handleReadOrDelete(id, status);
                                            }}
                                          >
                                            <img
                                              src={emailIcon}
                                              alt="email-icon"
                                              style={{
                                                marginRight: 12,
                                              }}
                                            />
                                          </Box>
                                          <Box
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.nativeEvent.stopImmediatePropagation();
                                              handleReadOrDelete(id);
                                            }}
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="delete-icon"
                                            />
                                          </Box>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                  <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                                    <Grid item xs={12} md={12} lg={9}>
                                      <Box className={classes.notificationDesc}>
                                        {(pushType === 'INDIVIDUAL' || pushType === 'BROADCAST') ? content : header}
                                      </Box>
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={3}>
                                      <Box className={classes.notificationDate}>
                                        {formatNotificationDate(createDate, langCd, 'DD MMM, HH:mm',
                                          snsList.list ? snsList.list.toady : '',
                                          snsList.list ? snsList.list.yesterday : '')}
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Box>
                          )
                        }
                      </>
                    ))
                  }
                  {isRequesting ? <LoadingIcon disabled={false} iconWidth="40px" /> : ''}
                </>
              ) : <Empty snsList={snsList} />
            }
            <CompletedBanner
              count={completedCount}
              show={completedShow}
              setCompletedShow={handleCloseCompleteBnnaer}
              label={completedLabel}
              onClick={handleClickUndo}
              undoText={(snsList.list && snsList.list.undo) || ''}
            />
          </Box>
        </Box>
        <Box className={classes.notifyDetailContainer}>
          {
            clickId ? (
              <NotificationDetail
                callApi={callApi}
                notifycation={notifycation}
                clickId={clickId}
                setclickId={setclickId}
                onReadOrDelete={handleReadOrDelete}
                redirectTo={redirectTo}
                snsInfo={snsInfo}
                snsList={snsList}
                setListSelect={setDisplaySelect}
                displayDetailSelect={displayDetailSelect}
                setDisplayDetailSelect={setDisplayDetailSelect}
              />
            ) : (
              <Box className={classes.emptyDetail}>
                <img src={bellIcon} alt="bell-icon" />
              </Box>
            )
          }
        </Box>
      </Box>
    );
});

Notification.propsType = {
  callApi: func,
  setMenuItem: func,
  redirectTo: func,
  wsData: object,
};

export default Notification;
